<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

import PageWrapper from "@/common/components/PageWrapper.vue";
import { useGetFabricksChipByIdQuery } from "@/fabricks/chips/api/queries";

definePage({
  meta: {
    auth: ["FabricksAdmin.Access"],
  },
});

const route = useRoute("/fabricks/chips/[chipId]");
const chipId = ref(route.params.chipId);
const { data: chip, isPending: loading } = useGetFabricksChipByIdQuery(
  chipId.value,
);

const tabs = computed(() => [
  {
    title: "Details",
    to: `/fabricks/chips/${chipId.value}/details`,
  },
  {
    title: "Taps",
    to: `/fabricks/chips/${chipId.value}/taps`,
  },
  {
    title: "Logs",
    to: `/fabricks/chips/${chipId.value}/logs`,
  },
]);
</script>

<template>
  <PageWrapper
    :is-pending="loading"
    title="Chip details"
    :breadcrumb-links="[
      {
        label: 'All Chips',
        to: '/fabricks/chips',
      },
      {
        label: 'Chip details',
        to: '#',
      },
    ]"
    :tabs="tabs"
  >
    <div v-if="chip">
      <RouterView
        v-slot="{ Component }"
        :chip="chip"
      >
        <Transition
          mode="out-in"
          name="fade"
        >
          <component
            :is="Component"
            :chip="chip"
          />
        </Transition>
      </RouterView>
    </div>
  </PageWrapper>
</template>
